module.exports = __webpack_public_path__ + "img/report.2f958283.png";